import React from "react";

import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const bot = [
    <svg
      fill="currentColor"
      viewBox="0 0 16 16"
      height="1em"
      width="1em"
      key={"bot"}
    >
      <path d="M6 12.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 004.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 01-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 013 9.219V8.062zm4.542-.827a.25.25 0 00-.217.068l-.92.9a24.767 24.767 0 01-1.871-.183.25.25 0 00-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 00.189-.071l.754-.736.847 1.71a.25.25 0 00.404.062l.932-.97a25.286 25.286 0 001.922-.188.25.25 0 00-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 00-.166.076l-.754.785-.842-1.7a.25.25 0 00-.182-.135z" />
      <path d="M8.5 1.866a1 1 0 10-1 0V3h-2A4.5 4.5 0 001 7.5V8a1 1 0 00-1 1v2a1 1 0 001 1v1a2 2 0 002 2h10a2 2 0 002-2v-1a1 1 0 001-1V9a1 1 0 00-1-1v-.5A4.5 4.5 0 0010.5 3h-2V1.866zM14 7.5V13a1 1 0 01-1 1H3a1 1 0 01-1-1V7.5A3.5 3.5 0 015.5 4h5A3.5 3.5 0 0114 7.5z" />
    </svg>,
  ];

  const platform = [
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      key={"platform"}
    >
      <path d="M24 0H0v9.541h24V0zm0 20.755H0V24h24v-3.245zM0 12.618h24v4.892H0v-4.892z" />
    </svg>,
  ];

  return (
    <>
      <div className="brand">
        <img
          alt="Clik"
          src="https://ci-cms.clik.vn/images/logo/logo-reverse.svg"
          width={30}
          height={30}
          style={{ backgroundColor: "#001529", padding: "2px" }}
        />
        <span>CommuniConnect CPanel</span>
      </div>
      <hr />
      <Menu mode="inline">
        <Menu.Item key="1">
          <NavLink to="/bot/list">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              {bot}
            </span>
            <span className="label">Bot</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/platform/list">
            <span className="icon">{platform}</span>
            <span className="label">Platform</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidenav;
